/** Catálogo c_FormaPago SAT (mismo conjunto que InvoiceForm). */
export const FORMA_PAGO_SAT_OPTIONS = [
  { value: '01', label: '01 - Efectivo' },
  { value: '02', label: '02 - Cheque nominativo' },
  { value: '03', label: '03 - Transferencia electrónica de fondos' },
  { value: '04', label: '04 - Tarjeta de crédito' },
  { value: '05', label: '05 - Monedero electrónico' },
  { value: '06', label: '06 - Dinero electrónico' },
  { value: '08', label: '08 - Vales de despensa' },
  { value: '12', label: '12 - Dación en pago' },
  { value: '13', label: '13 - Pago por subrogación' },
  { value: '14', label: '14 - Pago por consignación' },
  { value: '15', label: '15 - Condonación' },
  { value: '17', label: '17 - Compensación' },
  { value: '23', label: '23 - Novación' },
  { value: '24', label: '24 - Confusión' },
  { value: '25', label: '25 - Remisión de deuda' },
  { value: '26', label: '26 - Prescripción o caducidad' },
  { value: '27', label: '27 - A satisfacción del acreedor' },
  { value: '28', label: '28 - Tarjeta de débito' },
  { value: '29', label: '29 - Tarjeta de servicios' },
  { value: '30', label: '30 - Aplicación de anticipos' },
  { value: '31', label: '31 - Intermediario pagos' },
  { value: '99', label: '99 - Por definir' },
]

/** Formas válidas al registrar un pago ya recibido (REP: FormaDePagoP ≠ 99). */
export const FORMA_PAGO_SAT_OPTIONS_PAGO = FORMA_PAGO_SAT_OPTIONS.filter((o) => o.value !== '99')

const FORMA_PAGO_LABELS = Object.fromEntries(
  FORMA_PAGO_SAT_OPTIONS.map((o) => [o.value, o.label])
)

export const getFormaPagoSatLabel = (codigo) => {
  const code = String(codigo || '').trim()
  if (!code) return ''
  return FORMA_PAGO_LABELS[code] || code
}

export const paymentMethodToFormaPago = (method) => {
  const map = {
    CASH: '01',
    CHECK: '02',
    TRANSFER: '03',
    CARD: '04',
    OTHER: '99',
  }
  return map[method] || '99'
}

/** Deriva el método interno (cuenta bancaria, conciliación) desde c_FormaPago. */
export const formaPagoToPaymentMethod = (formaPago) => {
  const code = String(formaPago || '').trim()
  if (code === '01') return 'CASH'
  if (code === '02') return 'CHECK'
  if (code === '03') return 'TRANSFER'
  if (code === '04' || code === '28' || code === '29') return 'CARD'
  return 'OTHER'
}

export const formaPagoRequiereCuentaBancaria = (formaPago) => {
  const code = String(formaPago || '').trim()
  return code === '02' || code === '03'
}

/** Forma de pago por defecto al cambiar método CFDI (c_MetodoPago). */
export const formaPagoDefaultForMetodoPago = (metodoPago) => {
  const metodo = String(metodoPago || 'PUE').trim().toUpperCase()
  if (metodo === 'PPD') return '99'
  if (metodo === 'PUE') return '03'
  return '03'
}
